export default {
  one_time: "一次性",
  title: "选择适合您的套餐",
  subtitle: "所有新用户均可享受 {0} 天试用期 — 体验专业版功能。",
  free: "免费",
  basic: "基础版",
  pro: "专业版",
  month: "每月",
  year: "每年",
  freeSubtitle: "适合个人用户和测试使用",
  basicSubtitle: "适合中小型企业和团队",
  proSubtitle: "适合大型企业和专业团队",
  current: "当前套餐",
  current_plan: "当前套餐",
  try: "免费试用",
  upgrade: "立即升级",
  contact: "联系我们",
  contact_sales: "联系销售",
  calcs: "次计算",
  reports: "份报告",
  calls_per_month: "次/月",
  keys: "个密钥",
  calculations: "碳排放计算",
  f_reports: "PDF报告",
  f_factor: "基础排放因子",
  f_no_api: "无API访问权限",
  f_support: "邮箱/工单支持",
  priority_support: "优先技术支持",
  b_reports: "Excel报告",
  b_factor: "自定义排放因子",
  b_custom_logo: "自定义Logo",
  b_api_access: "API访问权限",
  p_dedicated_support: "专属客户支持",
  p_custom_solutions: "定制解决方案",
  p_training: "团队培训服务",
  refund: "如果您在试用期内不满意，可以",
  refund_btn: "申请退款",
  refund_suffix: "。",
  powered_by: "支付服务由",
  pay_provider: "paddle",
  paymentLegal: {
    title: "付款与法律声明",
    price_currency:
      "价格：价格以欧元显示，并通过我们的记录商户Paddle安全处理。根据您的所在地，可能适用相应税费。",
    vat_tax:
      "增值税：企业客户有责任申报任何适用的税费。我们目前不直接收取增值税，但Paddle会在需要时在结账时处理税费计算。",
    payment_method:
      "付款通过Paddle安全处理，支持主要信用卡、PayPal、Apple Pay和特定国家/地区的支付方式。不提供托管服务。",
    financial_liability: "我们不提供投资、交易或财务咨询服务。访问仅限于SaaS订阅。",
    refund_policy: "退款政策：",
    refund_guarantee: "我们为通过Paddle进行的所有首次订阅购买提供14天退款保证。",
    refund_request: "退款请求可以通过账单-订单页面或联系我们的支持团队随时提交。",
    right_of_withdrawal:
      "通过访问或使用任何付费功能——包括CBAM排放计算、报告生成、API使用或自动化审计计算——即表示您承认并同意根据欧盟消费者保护法规，在数字服务完全交付后放弃撤回权。",
    subscription_renewals:
      "续订后7天内提交的退款请求有资格获得退款。7天后提交的退款请求可能有资格根据未使用的计费周期部分获得按比例退款。如果在当前计费周期内已使用付费功能，则不允许续订退款。",
    buy_what_you_need: "未使用的积分可随时全额退款。已使用的积分不予退款。",
    refund_restrictions:
      "在以下情况下无法退款：已生成CBAM报告。已执行排放计算或与审计相关的计算。在计费周期内已使用任何付费API端点。怀疑存在欺诈、滥用或误用服务的行为。",
    after_refund_approval:
      "退款获批后：将立即撤销对所有付费功能的访问权限。您的账户将降级为免费套餐。所有未来的续订将被取消。剩余的免费套餐配额将根据原始免费分配的未消耗部分进行恢复，而不是重置为满额容量。",
  },
  vat_note: "价格不含适用的增值税。欧盟用户需缴纳当地增值税。",
  pay_per_use_desc: "按需付费，无需订阅",
  pay_per_use_benefits_title: "按需付费优势",
  pay_per_use_benefit1: "无需订阅",
  pay_per_use_benefit2: "只为所用付费",
  pay_per_use_benefit3: "永久有效",
  buy_credits: "购买积分",
  most_popular: "最受欢迎",
  save_with_annual: "年度套餐节省 {amount}",
  monthly: "月付",
  annually: "年付",
  enterprise: "企业版",
  enterpriseSubtitle: "为专业用户设计的定制解决方案",
  e_custom_solutions: "定制解决方案",
  start_trial: "注册时可享受 {0} 天试用期",
  all_paid_plans_include_free: "所有付费套餐均包含免费套餐的所有功能。",
  fq: {
    title: "账单与订阅常见问题",
    plans_q: "有哪些订阅套餐？",
    plans_a:
      "我们提供免费版（100次计算/月）、14天试用版（500次计算）、基础版（€49/月）、专业版（€99/月）和按需付费版（€1.5/次计算）。详情请参见价格页面。",
    upgrade_q: "我可以升级或降级套餐吗？",
    upgrade_a: "可以，随时在账户设置中即时升级或降级。更改立即生效并按比例调整。",
    trial_q: "免费试用如何运作？",
    trial_a:
      "新用户可获得 {0} 天试用期，享受完整专业版功能。除非升级，否则将恢复为免费版（{1} 次计算）。",
    autocharge_q: "我的订阅会自动续订吗？",
    autocharge_a: "是的，默认自动续订。可随时在账单设置中禁用。",
    payment_methods_q: "支持哪些付款方式？",
    payment_methods_a:
      "付款通过我们的官方支付提供商Paddle安全处理，支持主要信用卡、PayPal、Apple Pay和地区性支付方式。增值税和适用税费由Paddle在结账时自动计算。",
    invoice_q: "你们提供增值税发票吗？",
    invoice_a:
      "是的，付款后可获得符合增值税规定的发票。欧盟客户需要有效的增值税ID才能享受免税资格。",
    refund_q: "我可以申请退款吗？",
    refund_a: "可通过账户设置中的订阅页面提交退款请求。退款资格遵循我们的14天退款政策。",
    data_security_q: "我的数据如何受到保护？",
    data_security_a: "我们遵守GDPR，使用加密传输和安全存储。数据仅对您的账户私有。",
    cancel_q: "如果我取消会怎样？",
    cancel_a: "可随时在订阅设置中取消。访问权限持续到计费周期结束，然后恢复为免费版。",
  },
};
